

let global_devices = null;

exports.updateDevices = function(devices) {
	global_devices = devices;
}

exports.salesforceOpenContact = async function(session, inbound) {

	try {

		if(!window.sforce) {
			return;
		}

		let name = null;

		console.dir(session);

		if(!inbound) {
			name = session.request.ruri.user;
		}
		else {
			name = session.request.from.uri.user;
		}

		session.inbound = inbound;
		session.user = name;


		console.log('salesforceOpenContac name ' + name + ' , inbound ' + inbound);

		if(!name) {
			return;
		}

		window.sforce.opencti.runApex({
            		apexClass: 'RinblePhoneHelper',
            		methodName: 'searchContact',
            		methodParams: 'phone=' + name,
            		callback: function (response) {

				try {
					console.log('Contact Look up completed name ' + name);
					console.dir(response);
					if (response.success == true && response.returnValue && response.returnValue.runApex && response.returnValue.runApex.Id) {
						var contactId = response.returnValue.runApex.Id;
						// We got the contact now Open the Screen popup
						console.log('Opening PHone Contact here ' + name + ' , contactId ' + contactId);
						window.sforce.opencti.screenPop({
                            				type: window.sforce.opencti.SCREENPOP_TYPE.SOBJECT,
                            				params: {
                                				recordId: contactId
                            				}	
                        			});

					} else {
						// Lets create the contact
						console.log('Contact not found here name ' + name);
					}

				} catch(e) {
					console.error(e);
				}


			}

		});


	} catch(e) {
		console.error(e);
	}
}

exports.salesforceUpdateCallConnected = function(session) {
	try {
		session.connected_time = Math.floor(Date.now()/1000);
	} catch(e) {
		console.error(e);
	}
}

exports.salesforceLogACall = function(session) {

	try {

		if(!window.sforce) {
			return;
		}

		console.log('salesforceLogACall name ' + session.user+ ' , inbound ' + session.inbound);

		if(!session.user) {
			return;
		}


		let user_obj = JSON.parse(localStorage.getItem('userconfig'));

		let loggedUser = null;
		let user_id = null;

		for(let key in user_obj) {
			let device = user_obj[key];
			console.log('key ' + key);
			console.log('device.useVOIP ' + device.useVOIP);
			console.log('device.useVOIP ' + device.deviceId);
			if(device.useVOIP) {

				global_devices.forEach((element) => {
					console.dir(element);
					console.dir(device);
					if(element.device_id == device.deviceId) {
						loggedUser = element.nickname;
						user_id = element.user_id;
					}
				});
			}
		}

		console.log('loggedUser ' + loggedUser);

		if(!loggedUser) {
			// Some thing Wrong
			return;
		}

		let callType = session.inbound ? "Inbound" : "Outbound";
		let fromNumber = session.inbound ? session.user : loggedUser;
		let toNumber = session.inbound ? loggedUser : session.user;
		let duration = !session.connected_time ? 0 : (Math.floor(Date.now()/1000) - session.connected_time)



		window.sforce.opencti.runApex({
            		apexClass: 'RinblePhoneHelper',
            		methodName: 'searchContact',
            		methodParams: 'phone=' + session.user,
            		callback: function (response) {

				try {
					console.log('salesforceLogACall Contact Look up completed name ' + session.user);
					console.dir(response);
					if (response.success == true && response.returnValue && response.returnValue.runApex && response.returnValue.runApex.Id) {
						var contactId = response.returnValue.runApex.Id;

						sforce.opencti.runApex({
                            				apexClass: 'RinblePhoneHelper',
                            				methodName: 'logACall',
                            				methodParams: 'contactId=' + contactId +
                                				        '&duration=' + duration + 
                                				        '&fromNumber=' + fromNumber + 
                                				        '&toNumber=' + toNumber +
									'&userCallType=' + callType,				

                            					        callback: function(rr) {
                                						console.log('log a call status ' + rr);

									try {

										console.log('Log a call completed Opening PHone Contact here ' + session.user + ' , contactId ' + contactId);
										window.sforce.opencti.screenPop({
                            								type: window.sforce.opencti.SCREENPOP_TYPE.SOBJECT,
                            								params: {
                                								recordId: contactId
                            								}	
                        							});

									} catch(e) {
										console.error(e);
									}
                            				}
                        			});

						// We got the contact now Open the Screen popup
					
					} else {
						// Lets create the contact
						console.log('Contact not found here name ' + session.user);
					}

				} catch(e) {
					console.error(e);
				}


			}

		});


	} catch(e) {
		console.error(e);
	}

}
